<dmb-base-input
  [value]="value()"
  (valueChange)="onValueChanged($event)"
  [pending]="pending()"
  [errors]="errors()"
  [type]="type()"
  [placeholder]="placeholder()"
  [label]="label()"
  [required]="required()"
  [autoComplete]="autoComplete()"
  [helpText]="helpText()"
  (blurred)="onBlur($event)"
  [name]="name()"
  [readOnly]="readOnly()">
  <ng-content />
</dmb-base-input>
